module.exports = __webpack_public_path__ + "static/media/bees.a8386b72.png";